import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';
const SvgCreditCardOutlined = ({ size, title = 'CreditCardOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M19 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2zM3 10.91h18"
        />
    </svg>
);
export default withIcon(SvgCreditCardOutlined);
